<template>

<div>

    <div class="list-loader-outer">
        <transition name="loader-fade">
            <div class="list-loader" v-if="loading">
                <div class="loader"></div>
            </div>
        </transition>
    </div>

    <h1>Kunder
        <a href="/customers/new" class="btn btn-default btn-sm">
          Lägg till kund
        </a>
    </h1>

    <div class="searchbar">

        <form>

                <div class="block freetext" v-bind:class="{ active: search.text != '' && search.text != null }">
                    <input class="form-control" v-on:keyup="updateQuery()" v-model="search.text" placeholder="Sök på namn, e-post, telefon etc" />
                </div>

                <div class="block select-large" v-bind:class="{ active: search.portal }">
                    <label>
                        <select v-model="search.portal" v-on:change="updateQuery()">
                          <option v-bind:value="undefined">Portal</option>
                          <option value="webshop">Webshoppen</option>
                          <option value="benify">Benify</option>
                          <option value="epassi">Epassi</option>
                          <option value="soderberg">Söderberg och partners</option>
                          <option value="wellnet">Wellnet</option>
                          <option value="benefits">Benefits</option>
                          <option value="edenred">Edenred</option>
                          <option value="other">Övriga</option>
                        </select>
                    </label>
                </div>

                <div class="block select-large" v-bind:class="{ active: search.has_active_cards }">
                    <label>

                        <select v-model="search.has_active_cards" v-on:change="updateQuery()">
                            <option v-bind:value="undefined">Med och utan aktiva klippkort</option>
                            <option value="yes">Med aktiva klippkort</option>
                            <option value="no">Utan aktiva klippkort</option>

                        </select>
                    </label>
                </div>

                <div class="block" v-bind:class="{ active: search.newsletter == 1 }">
                    <label>
                        <input type="checkbox" v-on:change="updateQuery()" v-model="search.newsletter" /> Godkänt utskick
                    </label>
                </div>

                <a data-toggle="modal" data-target="#myModal" class="btn btn-sm btn-default pull-right">
                    <i class="fa fa-file" aria-hidden="true"></i> Spara excel
                </a>

    <br clear="all">

        </form>

    </div>

</div>

</template>

<script>

export default {
    props: {
        query: {
            required: true
        },
        loading: {}
    },
    data: function () {
        return {
            search: {}
        }
    },
    methods: {

        updateQuery: function () {
            this.$emit('search', this.search)
        }
    },
    watch: {
        query: function () {
            this.search = this.query
        }
    }
}

</script>
